import { type BadgeStatus, StatusBadge } from "@/components/ui/status-badge";
import type { SystemLogRow } from "@/hooks/use-system-logs";

/** System Log level → NOS StatusBadge semantics (error ramp, warning, info, muted). */
const LEVEL_STATUS: Record<SystemLogRow["level"], BadgeStatus> = {
  error: "failed",
  warn: "pending",
  info: "info",
  debug: "disabled",
};

const LEVEL_LABEL: Record<SystemLogRow["level"], string> = {
  error: "Error",
  warn: "Warn",
  info: "Info",
  debug: "Debug",
};

export function LogLevelBadge({ level }: { level: SystemLogRow["level"] }) {
  return <StatusBadge status={LEVEL_STATUS[level]}>{LEVEL_LABEL[level]}</StatusBadge>;
}
